<template>
    <error-message-card class="margin-bottom-normal" :message="errorMessage"/>
</template>

<script>
    import ErrorMessageCard from "./ErrorMessageCard";
    import {STEP_ERROR_MESSAGES} from "../../../../constants/proposal-step-errors";

    export default {
        name: "ProposalStepError",
        components: {
            ErrorMessageCard
        },
        props: {
            step: {
                type: Object
            }
        },
        computed: {
            errorMessage() {
                if (STEP_ERROR_MESSAGES[this.step.name] && STEP_ERROR_MESSAGES[this.step.name][this.step.error]) {
                    return STEP_ERROR_MESSAGES[this.step.name][this.step.error];
                } else {
                    return this.step.error.replace(/_/g, ' ');
                }
            },
        },
    }
</script>